var KMVP = KMVP || {}; // make sure KMVP is available

KMVP.datepicker = {
    bindDatepicker: function () {
        $('.js-datepicker').each(function () {
            var $this = $(this);
            var $form = $this.closest('form');
            var $parent = $this.parent();
            // hidden input element that is to be updated with the selected date
            var $transferInput = $parent.find('input[name="' + $this.data('input-name') + '"]');

            // this is for pressing enter after deleting the input field manually for reset
            // by default the enter key would call an onSelect with the datepicker date
            $this.bind('keydown', function (event) {
                if (event.which == 13) {
                    event.stopImmediatePropagation();
                    handleInputData($this, $form);
                }
            });

            function toDate(date) {
                if(!date) {
                    return null;
                }

                // add a time to a ISO8601 date to treat it as local time, otherwise UTC will be used
                if (typeof date === 'string' && date.length > 0 && date.indexOf('T') === -1) {
                    date += 'T00:00:00';
                }
                return new Date(date);
            }

            $this.datepicker({
                showHour: false,
                showMinute: false,
                // dateFormat: 'dd.mm.yy', // localized by jquery ui datepicker i18n js library
                altField: $transferInput,
                altFormat: $.datepicker.ISO_8601,
                minDate: toDate($this.data('minDate')),
                maxDate: toDate($this.data('maxDate')),
                showOn: "both",
                buttonText: "<i class='fa fa-calendar ui-datepicker-trigger-icon'></i>",
                onSelect: function () {
                	if ($this.data("onSelect")) {
                		eval($this.data("onSelect"));
                	}
                    if ($this.data("onChangeSubmit")) {
                        $form.submit();
                    } else {
                        $transferInput.trigger('change');
                    }
                },
                beforeShowDay: function (date) {
                    // usually for weekdaysFilter we have string like '1,2,3,4,5' 
                    // but if we have ONLY ONE day of week selected ( e.g. WEDNESDAY, weekdaysFilter=3 ) => type is number 
                    if (typeof $this.data('weekdaysFilter') === "string") {
                        if ($this.data('weekdaysFilter').split(",").indexOf(date.getDay().toString()) < 0) {
                            return [false];
                        }
                    } else if (typeof $this.data('weekdaysFilter') === "number") {
                        if ($this.data('weekdaysFilter') !== date.getDay()) {
                            return [false];
                        }
                    }
                    if (typeof $this.data('offDatesFilter') === "string") {
                        // date.toISOString takes date.getTimezoneOffset into account so we build the iso format with out this offset
                        var isoFormattedDate = [
                            date.getFullYear(),
                            ('0' + (date.getMonth() + 1)).slice(-2),
                            ('0' + date.getDate()).slice(-2)
                        ].join('-');
                        if ($this.data('offDatesFilter').split(",").indexOf(isoFormattedDate) >= 0) {
                            return [false];
                        }
                    }
                    return [true];
                }
            });

            // disable calendar if all products does not have individual delivery date
            if ($this.attr('data-input-name') === 'deliveryDateISO8601' && toDate($this.data('minDate')) === null) {
                $this.prop('disabled', true);
                $this.next('button').prop('disabled', true);
            }

            var dateStr = $transferInput.val();
            if (dateStr && !isNaN(Date.parse(dateStr))) {
                $this.datepicker("setDate", new Date(dateStr.replace(/-/g, '/')));
            }

            $this.change(function () {
                handleInputData($this, $form);
            });

            function handleInputData(inputField, form) {
                // datepicker doesn't reset when clearing the input field
                if (inputField.val().trim() === "") $.datepicker._clearDate(inputField.get());
                if (inputField.data("onChangeSubmit")) {
                    form.submit();
                }
            }

            $this.trigger('datepicker:initialized'); //new from andy
        });

        // "from" should not be later than "to" and vice versa
        var $from = $('.js-datepicker[data-input-name="from"]');
        var $to = $('.js-datepicker[data-input-name="to"]');
        if ($from.length > 0 && (date = $from.datepicker('getDate'))) {
            $to.datepicker('option', 'minDate', date);
        }
        if ($to.length > 0 && (date = $to.datepicker('getDate'))) {
            $from.datepicker('option', 'maxDate', date);
        }

    }
};

$(document).ready(function () {
    KMVP.datepicker.bindDatepicker();
});